module.exports = __webpack_public_path__ + "img/Chilean.cd5e1c1a.svg";